import {Modal} from 'shared/components/modals';
import {FormattedMessage} from 'react-intl';

const LocationErrorModal = ({modalOpen, uiState}) => {
  const {clockInEvent} = uiState;

  return (
    <Modal
      isOpen={modalOpen}
      onHide={() => uiState.closeLocationErrorModal()}
      size='sm'
      title={clockInEvent ? 'time_tracking.time_clock.Unable to Clock Out' : 'time_tracking.time_clock.Unable to Clock In'}
    >
      <div className='flex flex-col align-items-middle'>
        <i className='material-symbols-solid waterloo mb2' style={{fontSize: 56}}>{'wrong_location'}</i>
        <div className='mb1 medium h3'><FormattedMessage id='Your location could not be determined'/></div>
        <div className='jumbo center mb2'>
          <FormattedMessage id='time_tracking.time_clock.LOCATION_ERROR_MESSAGE'/>
        </div>
      </div>
    </Modal>
  );
};

export default LocationErrorModal;
